import * as antdEnUSLanguage from "antd/locale/en_US";
import * as antdZhCNSLanguage from "antd/locale/zh_CN";
import * as antdTwCNSLanguage from "antd/locale/zh_TW";

import { find } from "lodash";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

import { zhCN } from "./zh-CN";
import { enUS } from "./en-US";
import { zhTW } from "./zh-TW";

if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "zh-CN");
}

const languageSetting = () => {
  return localStorage.getItem("language") || navigator.language || "zh-CN";
};

const CURRENT_LANGUAGE = languageSetting();

export const languages = [
  {
    id: "en-US",
    locale: "en",
    name: "English",
    antd: antdEnUSLanguage.default,
    config: enUS
  },
  {
    id: "zh-CN",
    locale: "zh-cn",
    name: "简体中文",
    antd: antdZhCNSLanguage.default,
    config: zhCN
  },
  {
    id: "zh-TW",
    locale: "zh-tw",
    name: "繁体中文",
    antd: antdTwCNSLanguage.default,
    config: zhTW
  }
];

const config = find(languages, ["id", CURRENT_LANGUAGE]);
dayjs.locale("zh-cn");

export const language = config;

export const langCommon = language?.config.common;
export const langPage = language?.config.page;
export const langTableColumns = language?.config.tableColumns;
